export default __webpack_public_path__ + "static/media/BlackSlant.eb2c9353.svg";